<nav class="navbar navbar-expand-lg navbar-dark bg-dark hero-color shadow p-3">
    <a class="navbar-brand" href="#"><img src="../../assets/logoargus.png" width="221" height="64"></a>
    <button class="navbar-toggler" type="button" data-toggle="collapse" data-target="#navbarNavDropdown"
      aria-controls="navbarNavDropdown" aria-expanded="false" aria-label="Toggle navigation">
      <span class="navbar-toggler-icon"></span>
    </button>
    <div class="collapse navbar-collapse mr-5" id="navbarNavDropdown">
      <div class="navbar nav mr-auto"></div>
      <ul class="navbar-nav ">
        <li class="nav-item">
          <a class="nav-link link-navbar text-white" href="#home"><svg width="1em" height="1em" viewBox="0 0 16 16" class="bi bi-display-fill" fill="currentColor" xmlns="http://www.w3.org/2000/svg">
            <path d="M6 12c0 .667-.083 1.167-.25 1.5H5a.5.5 0 0 0 0 1h6a.5.5 0 0 0 0-1h-.75c-.167-.333-.25-.833-.25-1.5h4c2 0 2-2 2-2V4c0-2-2-2-2-2H2C0 2 0 4 0 4v6c0 2 2 2 2 2h4z"/>
          </svg>&nbsp;&nbsp;Home</a>
        </li>
        <li class="nav-item">
          <a class="nav-link link-navbar text-white" href="#argus"><img src="../../assets/iconmenu.png" height="18px">&nbsp;&nbsp;Argus</a>
        </li>
        <li class="nav-item">
          <a class="nav-link link-navbar text-white" href="#diferenciais"><svg width="1em" height="1em" viewBox="0 0 16 16" class="bi bi-filter-circle-fill" fill="currentColor" xmlns="http://www.w3.org/2000/svg">
            <path fill-rule="evenodd" d="M8 16A8 8 0 1 0 8 0a8 8 0 0 0 0 16zM3.5 5a.5.5 0 0 0 0 1h9a.5.5 0 0 0 0-1h-9zM5 8.5a.5.5 0 0 1 .5-.5h5a.5.5 0 0 1 0 1h-5a.5.5 0 0 1-.5-.5zm2 3a.5.5 0 0 1 .5-.5h1a.5.5 0 0 1 0 1h-1a.5.5 0 0 1-.5-.5z"/>
          </svg>&nbsp;&nbsp;Diferenciais</a>
        </li>
        <li class="nav-item">
          <a class="nav-link link-navbar text-white" href="#contato"><svg width="1em" height="1em" viewBox="0 0 16 16" class="bi bi-envelope-open-fill" fill="currentColor" xmlns="http://www.w3.org/2000/svg">
            <path d="M8.941.435a2 2 0 0 0-1.882 0l-6 3.2A2 2 0 0 0 0 5.4v.313l6.709 3.933L8 8.928l1.291.717L16 5.715V5.4a2 2 0 0 0-1.059-1.765l-6-3.2zM16 6.873l-5.693 3.337L16 13.372v-6.5zm-.059 7.611L8 10.072.059 14.484A2 2 0 0 0 2 16h12a2 2 0 0 0 1.941-1.516zM0 13.373l5.693-3.163L0 6.873v6.5z"/>
          </svg>&nbsp;&nbsp;Contato</a>
        </li>
        
      </ul>
    </div>
  </nav>